import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ConfirmDialogProps } from '../types';

// ----------------------------------------------------------------------

export default function ConfirmDialog({
  title,
  content,
  action,
  open,
  onClose,
  maxWidth,
  bgColor,
  hasCancel = true,
  hasXButton = true,
  noPadding = false,
  ...other
}: ConfirmDialogProps) {
  return <Dialog fullWidth maxWidth={maxWidth ?? 'xs'} open={open} onClose={onClose} {...other} data-sentry-element="Dialog" data-sentry-component="ConfirmDialog" data-sentry-source-file="index.tsx">
      {hasXButton && <IconButton sx={{
      bgcolor: 'transparent',
      ':hover': {
        bgColor: 'transparent'
      },
      position: 'absolute',
      top: 8,
      left: 8
    }} onClick={onClose}>
          <CloseIcon />
        </IconButton>}

      {title && <DialogTitle width='100%' display='flex' flexDirection='row' justifyContent='center' sx={{
      pb: 2
    }}>
          {title}
        </DialogTitle>}

      {content && <DialogContent sx={{
      typography: 'body2',
      bgcolor: bgColor ?? 'background.paper',
      px: noPadding ? 0 : 3
    }}>
          {content}
        </DialogContent>}

      {(action || hasCancel) && <DialogActions>
          {action}

          {hasCancel && <Button variant='outlined' color='inherit' onClick={onClose}>
              Cancel
            </Button>}
        </DialogActions>}
    </Dialog>;
}